import React from 'react';
import { createRoot } from 'react-dom/client';
import jwtUtils from '../utilities/jwtUtils.jsx';
import { clearLoginAlertSessionState } from '../utilities/gestionMorasSession';
import { fetchWithAuth, logout as clearAuthSession } from '../js/authToken.js';
import API_BASE_URL from '../js/urlHelper';
import FetchWithGif from '../components/Reutilizables/FetchWithGif.jsx';

export function completeLocalLogout() {
  clearLoginAlertSessionState();
  clearAuthSession();
}

export async function logout() {
  // Crear contenedor temporal para FetchWithGif
  const container = document.createElement('div');
  document.body.appendChild(container);
  const root = createRoot(container);

  try {
    // Mostrar FetchWithGif
    root.render(<FetchWithGif />);

    // Obtener el ID del refresh token desde la cookie
    const idToken = jwtUtils.getRefreshTokenIDFromCookie();

    if (idToken) {
      // Llamar al backend para eliminar la sesión
      await fetchWithAuth(`${API_BASE_URL}/api/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ idToken }),
      });

      // Procesar la respuesta
     // const data = await response.json();
      // if (response.ok && data.message === 'OK') {
      //   console.log('Sesión eliminada exitosamente');
      // } else {
      //   console.warn('Error en la respuesta del backend:', data.message);
      // }
    } else {
      console.warn('No se encontró idToken, omitiendo llamada al backend');
    }

    completeLocalLogout();
  } catch (error) {
    console.error('Error durante el logout:', error);
    completeLocalLogout();
  } finally {
    // Ocultar FetchWithGif y limpiar el contenedor
    root.unmount();
    document.body.removeChild(container);
  }
}

window.logout = logout;